var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-report',{attrs:{"title":"Packages Report","subtitle":"View newly created packages and completed ones.","initial-filters":_vm.initialFilters},scopedSlots:_vm._u([{key:"default",fn:function({ filters }){return [_c('reports-packages-new',{attrs:{"filters":filters}}),_vm._v(" "),_c('reports-packages-completed',{attrs:{"filters":filters}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }